var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"row-key":"id","split-count":10,"url":_vm.table_url,"setting":_vm.setting,"fixed-row-action":"","reserve-selection":"","hooks":{
      beforeSearch: _vm.beforeSearch
    }}}),_c('ImportDialog',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"importDialog",attrs:{"buttonName":"导入","buttonSize":"medium","fileName":"导入地址片段关键词","fileType":"black_address"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }